var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 17 208.84 134.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.44,48.78A22.21,22.21,0,0,1,197,70.5v58.84a21.42,21.42,0,0,0,21.42,21.43h9.73V70.85c0-29.22-23.3-53.63-52.52-53.85a52.56,52.56,0,0,0-25.16,6.17A90.79,90.79,0,0,1,167.6,49.56,21.46,21.46,0,0,1,180.44,48.78Z",
    fill: "#2f4157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24,129.34v-9.72H87.47c-19.44,0-35.84-15.28-36.32-34.71A35.65,35.65,0,0,1,87.63,48.43c19.43.48,34.71,16.88,34.71,36.32v44.59a21.42,21.42,0,0,0,21.42,21.43h9.73v-67h0a66.74,66.74,0,1,0-66.74,67H109.6A39.15,39.15,0,0,1,103.24,129.34Z",
    fill: "#2f4157"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.5ddc8494243d65d5f827997c73aeca86.svg";
export { ForwardRef as ReactComponent };